import * as React from 'react';
import { ICommand, ICommandStateProps } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { FollowAction } from '../../actions/follow/FollowAction';
import CommandStrings from '../Commands.resx';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

export const followCommand: ICommand = {
  key: new Facet('follow').id,
  automationId: 'followCommand',
  action: <FollowAction />,
  name: CommandStrings.SaveForLater,
  commandBarButtonAs: (props: IComponentAsProps<ICommandBarItemProps> & ICommandStateProps) => {
    const DefaultRender = props.defaultRender;
    const isToggled = props.actionState && props.actionState.isToggled;
    const name = isToggled ? CommandStrings.RemoveFromSaved : CommandStrings.SaveForLater;
    return (
      DefaultRender ?
        (
          <DefaultRender
            { ...props }
            iconProps={
              { iconName: isToggled ? 'SingleBookmarkSolid' : 'SingleBookmark' }
            }
            name={ name }
            text={ name }
          />
        ) : null
    );
  }
};